import { SubscriptionDuration, SubscriptionPlanType } from "@shared/types";
import { BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH } from "common/constants";
import { PROMO_CODE_QUERY_PARAM } from "features/settings/common/constants";
import { SubscriptionStep } from "@shared/features/settings/subscription/types";
import {
  SubscriptionInvoiceType,
  SubscriptionInvoiceTypeValueType,
} from "analytics/Avo";
import { SUBSCRIPTION_QUERY_PARAMS } from "@shared/features/settings/subscription/constants";

export const getPurchaseSubscriptionPath = ({
  isUpgrade,
  step,
  isAllPlans,
  plan,
  duration,
  promoCode,
}: {
  isUpgrade?: boolean;
  step?: SubscriptionStep;
  isAllPlans?: boolean;
  plan?: SubscriptionPlanType;
  duration?: SubscriptionDuration;
  promoCode?: string | null;
}) => {
  let basePath = BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH;
  const query = new URLSearchParams();
  if (isUpgrade) query.set(SUBSCRIPTION_QUERY_PARAMS.IS_UPGRADE, "1");
  if (step) query.set(SUBSCRIPTION_QUERY_PARAMS.STEP, step);
  if (isAllPlans) query.set(SUBSCRIPTION_QUERY_PARAMS.IS_ALL_PLANS, "1");
  if (plan) query.set(SUBSCRIPTION_QUERY_PARAMS.PLAN, plan.toString());
  if (duration)
    query.set(SUBSCRIPTION_QUERY_PARAMS.DURATION, duration.toString());
  if (promoCode) query.set(PROMO_CODE_QUERY_PARAM, promoCode);

  if (step || isAllPlans || plan || duration || promoCode || isUpgrade) {
    basePath += `?${query.toString()}`;
  }

  return basePath;
};

export const getAvoInvoiceType = (
  isUpgrade?: boolean,
  isExtend?: boolean,
  isGroup?: boolean
): SubscriptionInvoiceTypeValueType => {
  let invoiceType: SubscriptionInvoiceTypeValueType =
    SubscriptionInvoiceType.NEW;
  if (isGroup) {
    invoiceType = SubscriptionInvoiceType.SIGNALS_GROUP_EXTENSION;
  } else if (isUpgrade) {
    invoiceType = SubscriptionInvoiceType.UPGRADE;
  } else if (isExtend) {
    invoiceType = SubscriptionInvoiceType.EXTENSION;
  }
  return invoiceType;
};
